import { Card, Checkbox, Col, Row, Table } from "antd";
import moment from "moment";
import { useState } from "react";

const InvoiceSummary = ({ data, selectedInvoice, interesFlag }) => {
  const [paymentMethods, setPaymentMethods] = useState([]);

  const handleCheckboxChange = (id, checked) => {
    let updatedMethods;

    if (checked) {
      // Si se marca el checkbox, agregamos el ID del método de pago al estado
      updatedMethods = [...paymentMethods, id];
    } else {
      // Si se desmarca el checkbox, eliminamos el ID del método de pago del estado
      updatedMethods = paymentMethods.filter((method) => method !== id);
    }

    setPaymentMethods(updatedMethods);
  };
  const calculateinterest= ()=>{

  }
  const totalSum = Object.values(data).reduce(
    (accumulator, employee) =>
      accumulator +
      employee.reduce(
        (empAccumulator, emp) => empAccumulator + emp.calculatedSalary,
        0
      ),
    0
  );
  //const totalInteres = (selectedInvoice?.interest && selectedInvoice?.interest>0) ? totalSum *  (selectedInvoice.interest / 100) : 0;
  const totalInteres = (interesFlag && selectedInvoice?.interest && selectedInvoice?.interest>0) ? totalSum *  (selectedInvoice.interest / 100) : 0;
  const totalSumInteres =  totalSum + totalInteres;

  const filteredData = Object.keys(data)
    .filter((percent) => Number(percent) !== 0)
    .map((percent) => ({
      percent,
      totalSalary: data[percent].reduce(
        (accumulator, employee) => accumulator + employee.calculatedSalary,
        0
      ),
      cantEmpleados: data[percent].length,
    }));

  return (
    <div
      style={{
        padding: 10,
        marginBottom: "20px",
        backgroundColor: "#f7f7f7",
      }}
    >
      <Row>
        <Col span={24}>
          <Card
            size="small"
            style={{ textAlign: "left", marginBottom: "5px" }}
            title="Datos de facturación"
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <p>
                  <strong>Empresa: </strong>
                  {selectedInvoice.company.name}
                </p>
                <p>
                  <strong>Factura Nº: {selectedInvoice.invoiceNumber}</strong>
                </p>
                <p>
                  <strong>Tipo Factura:  {selectedInvoice.tipoFactura} </strong>
                 
                </p>
              </div>
              <div>
                <p>
                  <strong>Fecha de solicitud: </strong>
                  {moment(Date(selectedInvoice.createdAt)).format("DD/MM/YYYY")}
                </p>
                <p>
                  <strong>Período a facturar: </strong>
                  {moment(selectedInvoice.period[0]).format("DD/MM/YYYY") +
                    " - " +
                    moment(selectedInvoice.period[1]).format("DD/MM/YYYY")}
                </p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Card
            size="small"
            title="Medio de pago"
            style={{ textAlign: "left", marginBottom: "5px",  }}
          >
            <Checkbox
              onChange={(e) =>
                handleCheckboxChange("efectivo", e.target.checked)
              }
            >
              Efectivo
            </Checkbox>
            <Checkbox
              onChange={(e) => handleCheckboxChange("cheque", e.target.checked)}
            >
              Cheque
            </Checkbox>
            <Checkbox
              onChange={(e) =>
                handleCheckboxChange("transferencia", e.target.checked)
              }
            >
              Transferencia
            </Checkbox>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {Object.keys(data).length > 0 && (
            <Card title="Detalle" size="small">
              <Table
                style={{
                  maxHeight: "410px",
                  overflowY: "auto",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
                pagination={false}
                dataSource={filteredData}
                columns={[
                  {
                    title: "Porcentaje",
                    dataIndex: "percent",
                    key: "percent",
                    render: (value) => `${value} %`,
                  },
                  {
                    title: "Cant. Empleados",
                    dataIndex: "cantEmpleados",
                    key: "cantEmpleados",
                    align: "right",
                  },
                  {
                    title: "Total Acumulado",
                    dataIndex: "totalSalary",
                    key: "totalSalary",
                    align: "right",
                    render: (value) => `$ ${value.toLocaleString("de-DE")}`,
                  },
                ]}
              />
            </Card>
          )}
          <div
            style={{
              justifyContent: "end",
              display: "flex",
              flexDirection:"column",
              marginTop: "5px",
              textAlign:"right",
            }}
          >
            <h5 style={{ borderBottom: "1px dashed #ccc", padding:"10px 20px",}}>SubTotal:$ {parseFloat(totalSum).toFixed(1).toLocaleString("de-DE")}</h5>
            <h5 style={{ borderBottom: "1px dashed #ccc", padding:"10px 20px",}}>Intereses ({selectedInvoice.interest}%) : ${parseFloat(totalInteres).toFixed(1).toLocaleString("de-DE")}</h5>
            <h4 style={{ padding:"5px 20px",}}>Total:$ { parseFloat(totalSumInteres).toFixed(1).toLocaleString("de-DE")}</h4>

          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InvoiceSummary;
